export default "__VITE_ASSET__DDBurO6x__"